var render = function render(){var _vm=this,_c=_vm._self._c;return _c('onboarding-layout',{attrs:{"current-step":0}},[_c('organization-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }